/* ============
 * BillsReport Transformer
 * ============
 *
 * todo: add documentation here!
 */

import Transformer from './transformer';

export default class BillsReportTransformer extends Transformer {

  static fetch(item) {
    return {
      invoiceNumber: item.billing_number,
      billTypeName: item.bill_type_name,
      status: item.status,
      invoiceDate: item.bill_date,
      dueDate: item.due_date,
      customer: item.customer,
      email: item.email,
      address: item.address,
      sum: (item.sum) ? item.sum : 0,
      vat: (item.vat) ? item.vat : 0,
      invoiceAmount: (item.invoice_amount) ? item.invoice_amount : 0,
      balance: (item.balance) ? item.balance : 0,
      id: item.id,
    };
  }

  static send() {
    return {
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/billsReport.js